import React, { useState, useEffect } from "react";
import {
  getSettings,
  updateSettings,
} from "../../../services/settingsServices";
import Button from "../../../components/Button/Button";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

// Définir les modules pour la barre d'outils
const modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ color: [] }, { background: [] }], // Ajout des options de couleur de texte et d'arrière-plan
    [{ script: "sub" }, { script: "super" }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ],
};

// Définir les formats pris en charge
const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "color",
  "background", // Inclusion des formats de couleur de texte et d'arrière-plan
  "script",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
];

const InfoClubForm = () => {
  const [settings, setSettings] = useState({
    infoclub_isactive: true,
    infoclub_title: "",
    infoclub_content: "",
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const settingsData = await getSettings();
        if (settingsData.length > 0) {
          setSettings(settingsData[0]);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des données:", error);
      }
      setLoading(false);
    };

    fetchSettings();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: value,
    }));
  };

  const handleContentChange = (name, value) => {
    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateSettings(settings);
      toast.success("Paramètres mis à jour avec succès");
    } catch (error) {
      toast.error("Erreur lors de la mise à jour des paramètres");
    }
  };

  if (loading) return <div>Chargement...</div>;

  return (
    <div className="bg-white dark:bg-slate-300 shadow-md rounded-lg p-4 max-w-[1280px] mx-auto">
      <h3 className="text-xl font-semibold mb-6">
        Paramétrer Info Club sur page Accueil
      </h3>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Activer ou désactiver la section Info Club */}
        <div className="flex items-center space-x-3">
          <span className="text-sm font-medium text-gray-700">
            Activer la section Info Club
          </span>
          <button
            type="button"
            className={`w-12 h-6 flex items-center rounded-full p-1 transition-colors duration-300 ${
              settings.infoclub_isactive ? "bg-green-500" : "bg-gray-300"
            }`}
            onClick={() =>
              setSettings((prev) => ({
                ...prev,
                infoclub_isactive: !prev.infoclub_isactive,
              }))
            }
          >
            <div
              className={`w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
                settings.infoclub_isactive ? "translate-x-6" : "translate-x-0"
              }`}
            />
          </button>
        </div>

        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">
            Titre de la section Info Club
          </label>
          <input
            type="text"
            name="infoclub_title"
            value={settings.infoclub_title}
            onChange={handleChange}
            className="input input-bordered w-full"
          />
        </div>
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">
            Contenu de la section Info Club
          </label>
          <ReactQuill
            value={settings.infoclub_content}
            onChange={(value) => handleContentChange("infoclub_content", value)}
            className="mb-3 bg-slate-200 dark:bg-slate-100 dark:text-black"
            modules={modules}
            formats={formats}
          />
        </div>

        <div className="flex justify-end">
          <Button
            text="Mettre à jour"
            type="submit"
            className="btn-primary gap-2"
          />
        </div>
      </form>
    </div>
  );
};

export default InfoClubForm;
